const CONSENT_KEY = "cookie_consent";

export type ConsentValue = "accepted" | "declined";

export function getConsent(): ConsentValue | null {
  try {
    const v = localStorage.getItem(CONSENT_KEY);
    return v === "accepted" || v === "declined" ? v : null;
  } catch {
    return null;
  }
}

export function setConsent(value: ConsentValue) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // storage unavailable
  }
}

export function hasAnalyticsConsent(): boolean {
  return getConsent() === "accepted";
}
